import { useProducts } from '../../features/catalog/queries.js';
import { Section, SectionHeading } from '../layout/Section.jsx';
import { ProductGrid } from './ProductGrid.jsx';

/**
 * One home page shelf for one collection.
 *
 * The home page draws one of these for every published collection, in the
 * order the admin panel sets, so a collection an operator creates or renames
 * shows here under its own name with no deploy. Nothing is keyed on a category
 * slug, which is what made the old attar shelf vanish the moment its category
 * was renamed.
 *
 * A collection with nothing published steps aside entirely. It also stays out
 * while its query is in flight: an empty collection would otherwise flash a
 * row of skeletons and then collapse, moving everything below it.
 */
export const CollectionShelf = ({ collection, onQuickAdd, className }) => {
  const products = useProducts({ world: collection.slug, sort: 'newest', limit: 10 });

  if (!products.data?.length) return null;

  return (
    <Section className={className}>
      <SectionHeading
        eyebrow="Collection"
        title={collection.name}
        description={collection.tagline || undefined}
        action={{ label: `See all ${collection.name.toLowerCase()}`, to: `/shop?world=${collection.slug}` }}
      />
      <ProductGrid products={products.data} isPending={false} onQuickAdd={onQuickAdd} />
    </Section>
  );
};

export default CollectionShelf;
